// extracted by mini-css-extract-plugin
module.exports = {"container":"_3eys5","actions-header":"_3uVFX","actionsHeader":"_3uVFX","content":"YAwT3","iframe-container":"_2IkjN","iframeContainer":"_2IkjN"};